<ng-container *transloco="let t">
  <div class="align-items-center d-flex d-lg-none">
    <div class="pe-4 fw-bolder fs-5">
      <span [class.opacity-25]="!(liveResult?.rank)">{{liveResult?.rank ?? '00'}}</span>
    </div>
    <div class="d-flex flex-column py-3 flex-grow-1" [class.item-border-bottom]="hasBorderBottom">
      <div class="fw-bold line-height-12">  {{((liveResult?.firstName ?? "")| titlecase) + " " + ((liveResult?.lastName
        ?? "") | titlecase)}}, <span
        class="fs-13-px fw-semibold">{{liveResult?.club ?? ""}} {{liveResult?.club || liveResult?.category ? "/" : "" }}
        {{liveResult?.category ?? ""}}
        </span>
      </div>
      <div class="d-flex flex-column fs-13-px fw-semibold">
        <div>
          {{t('competitor.table.start.number')}} {{': '}} {{liveResult?.startNumber ?? ""}}
        </div>
        <span>{{t("live.results.events.results.table.time") + ": " + (liveResult?.totalTime ?? "" | formatTime)}}</span>
        <span>{{t("live.results.events.results.table.gap") + ": " + (liveResult?.gap ?? "")}}</span>
        <span>{{t("live.results.events.results.table.laps") + ": " + (liveResult?.lapCount ?? "")}}</span>
      </div>
    </div>
  </div>
</ng-container>
